import React from 'react';
import './appPage.css';
import { Button, Box, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ScrollDialog from '../../Components/ScrollDialog';
import SingleLineImageList from '../../Components/ImageList';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import DialogContentText from '@mui/material/DialogContentText';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import getOS from '../../Components/GetOS';
import addDecimal from '../../Components/addDecimal';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



const buttonStyle = {
    marginTop: '1%',
    height: 'auto',
    color: '#050A44',
    fontSize: {md: '15px', sm: '15px', xs: '10px'},
    boxShadow: "5",
    backgroundColor: '#141619',
    borderColor: '#141419',
    "&:hover": {
      backgroundColor: '#050A44',
      borderColor: '#141419',
      WebkitTextFillColor: 'white',
      boxShadow: "15",
    }
  }
  
  function BackSeatPage (props){
    let OS = getOS();
    let backSeatApps = props.comps['backSeatApps'];
    let driverApps = props.comps['driverApps'];
    let bookingApps = props.comps['bookingApps'];
    sessionStorage.setItem("uploadCount", 0)
    const company = backSeatApps.find(c => c.navLink === props.match.url);
    const bookingConnect = bookingApps.find(c => c.iAffiliateID === company.iAffiliateID);
    const driverConnect = driverApps.find(c => c.iAffiliateID === company.iAffiliateID);
  
    if (!company) {
      return <div>Company not found</div>;
    }
  
    let { name, appType, aboutApp, versionNo, versionInfo, releaseDate, downloadLink, BGPhoto, testingLink, testingVersion, previousVersionInfo, screenshots, googleLink, appleLink} = company;
    BGPhoto = encodeURIComponent(BGPhoto)
  
    let appStoreLink = ''
    if (OS === 'iOS' && appleLink){
      appStoreLink = appleLink
    }
  
    if (OS === 'Android' && googleLink){
      appStoreLink = googleLink
    }

    return (
        <Box sx={{ flexGrow: 1, width: '100%', height:'100%' }}>
        <Grid container sx={{paddingBottom: '5%'}} spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid  container size={{ xs: 4, sm: 8, md: 12 }}>
                <Grid  sx={{width: '100%', height: '100%'}} size={{ xs: 4, sm: 8, md: 12 }}>
                    <div className='bigDiv'>
                    <div className='img'>
                    <img src={BGPhoto} className='bigPhoto' srcSet={`${BGPhoto} 1920w, ${BGPhoto} 800w, ${BGPhoto} 400w`} alt={name} />
                    </div>
                    </div>
                    <Stack textAlign="left">
                        <Typography gutterBottom variant='h5' align='left' sx={{marginLeft: '10%', fontWeight: '800' }}>
                            {name} {appType} App
                        </Typography>

                        <Stack textAlign="left" direction="row" sx={{marginLeft: '10%',}}>
                            <Stack>
                            {( appStoreLink !== '') ? 
                                (<Button
                                    sx={buttonStyle}
                                    variant="outlined"
                                    component={Link} to={appStoreLink} target="_blank" rel="noopener noreferrer" 
                                    startIcon={<CloudDownloadOutlinedIcon />}
                                >
                                    Download 
                                </Button>) :

                                (<Button
                                    sx={buttonStyle}
                                    variant="outlined"
                                    href={downloadLink}
                                    startIcon={<CloudDownloadOutlinedIcon />}
                                >
                                    Download
                                </Button>)}

                                <Typography gutterBottom align='left' sx={{marginTop: '3%'}}>
                                    Current Version: {addDecimal(versionNo)}
                                </Typography>
                            </Stack>

                            <Stack textAlign="left"sx={{marginLeft: '5%', marginRight: 4}}>
                            {/* Testing version download and description */}    
                            {(testingLink !== "") && 
                                ( <> <Button
                                    sx={buttonStyle}
                                    variant="outlined"
                                    href={testingLink}
                                    startIcon={<CloudDownloadOutlinedIcon />}
                                >
                                    Download (Test)
                                </Button>
          
                                <Typography gutterBottom align='left' sx={{marginTop: '3%'}}>
                                    Testing Version: {testingVersion}
                                </Typography> </>)}
                            </Stack>  
                        </Stack>
                            <b className='whatsNew'><ScrollDialog aboutApp={versionInfo} versionInfo={null} title="What's new" /></b>
                        
                            <DialogContentText
                                id="scroll-dialog-description"
                                tabIndex={-1}
                                className='newNotes'
                                sx={{whiteSpace: 'pre-line', marginLeft: '10%', marginTop:'1%', color: '#141619'}}
                                component={'span'}
                                > 
                                    {versionInfo} 
                                </DialogContentText>
                    </Stack>
                </Grid>
            </Grid>
            
                    {
                    <Grid  sx={{marginLeft: {md:'10%', xs:'10%', sm: '10%'}}} size={{ xs: 3, sm: 6, md: 8 }}>
                        <SingleLineImageList screenshotList={screenshots}/>
                    </Grid>}

                <Grid  sx={{flexGrow: 1, display: 'flex', 
                                flexWrap: 'wrap', 
                                flexDirection: 'column', 
                                maxWidth: '410px', maxHeight: '390px',
                                textAlign: 'left',
                                backgroundColor: 'transparent', 
                                marginRight: 3,
                                marginLeft: {md: '0%', xs:'10%', sm: '10%'}}} 
                                size={2} >
                    {(bookingConnect || driverConnect) && 
                    (<Typography sx={{fontWeight: '600', fontSize: '20px'}}>Other apps for this affiliate</Typography>)}
                    {bookingConnect && 

                    <Grid  className='Connect'>
                        <Link to={bookingConnect.navLink}>
                            <Stack direction="row">
                                <img className='associatedImg' src={bookingConnect.appLogo} alt={'preview for booking app'}/>
                                <Stack textAlign='left' sx={{marginLeft: '5%', marginTop: '5%'}}>
                                    <Typography className='associatedAppName'>{bookingConnect.name} {bookingConnect.appType} App</Typography>
                                    <Typography> ITCurves </Typography>
                                </Stack>
                            </Stack>
                        </Link>
                    </Grid>}

                    {driverConnect && 
                    (<Grid  className='Connect'>
                        <Link to={driverConnect.navLink}>
                            <Stack direction="row">
                                <img className='associatedImg' src={driverConnect.appLogo} alt={'preview for driver app'}/>
                                <Stack textAlign='left' sx={{marginLeft: '5%', marginTop: '5%'}}>
                                    <Typography className='associatedAppName'>{driverConnect.name} {driverConnect.appType} App</Typography>
                                    <Typography> ITCurves </Typography>
                                </Stack>
                            </Stack>
                        </Link>
                    </Grid>)}
                </Grid>
                
                <Grid  sx={{width: '100%', height: '100%'}} size={{ xs: 3, sm: 6, md: 8 }}>
                    <Stack textAlign="left">
                        <b className='aboutApp'><ScrollDialog aboutApp={aboutApp} versionInfo={null} title="About this app" /></b>
                        <DialogContentText
                                id="scroll-dialog-description"
                                tabIndex={-1}
                                className='notesPreview'
                                sx={{whiteSpace: 'pre-line', marginLeft:{xs: '11%', sm: '15%', md: '15%'}, color: '#141619'}}
                                component={'span'}
                                > 
                                    {aboutApp} 
                                </DialogContentText>
                        <span className='updatedDate'>
                            <Typography sx={{marginLeft:{xs: '11%', sm: '15%', md: '15%'}, fontWeight: '600', marginTop: '2%'}} className='updated'>Updated on:</Typography>
                            <Typography sx={{marginLeft:{xs: '11.5%', sm: '15.5%', md: '15.5%'}}} className='releaseDate'>{releaseDate}</Typography>
                        </span>
                    </Stack>
                </Grid>
                {/* Talks about previous releases */}
                {Object.keys(previousVersionInfo).length !== 0  && 
                    <Grid sx={{marginLeft:{xs: '11%', sm: '15%', md: '15%'}}} > 
                        <Stack >
                            <ScrollDialog versionInfo={previousVersionInfo} title='Release History'/>
                        </Stack>
                    </Grid>}

            </Grid>
        </Box>
    );


};

BackSeatPage.propTypes = {
    match: PropTypes.any,
    comps: PropTypes.any,
  }
  
  
  export default BackSeatPage;


